import {APP_BASE_HREF} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {Params, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {selectFeatureFlag} from '@ox/data';
import {UIFeatureFlag} from '@ox/typings';
import {WINDOW} from '@ox/utils';
import {takeWhile, tap} from 'rxjs';

@Injectable()
export class TrackingUrlService {
  paymentHistoryRedesign: boolean;

  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(APP_BASE_HREF) private _baseHref: string,
    private store: Store,
    private router: Router
  ) {
    this.store
    .select(selectFeatureFlag({id: UIFeatureFlag.PAYMENT_HISTORY_REDESIGN, group: 'UI'}))
    .pipe(
      takeWhile((val) => !val, true),
      tap((flag) => this.paymentHistoryRedesign = flag === 'true')
    ).subscribe();
  }

  navigateToPaymentMethodPage = (buttonText: string, trackingString: string, toggleTab?: string) => {
    /**
     * Tracking params needed for webu
     * TODO: Remove and use normal directive when MFE payment history is created
     */
    this.redirectToBuiltURL(this.determineParams(buttonText, trackingString, toggleTab));
  };
  
  determineParams = (buttonText: string, trackingString: string, toggleTab?: string) => {
    if (!buttonText || !trackingString) return {}; // return empty object if either of the params are missing
    const params: Params = {
      trackLink: buttonText,
      prop10: trackingString,
      prop15: buttonText,
      evar33: trackingString
    };
    if (this.paymentHistoryRedesign) {
      params['isDefault'] = toggleTab;
    }
    return params;
  };
  
  redirectToBuiltURL = (params: Params) => {
    if (this.paymentHistoryRedesign) {
      this.router.navigate(['/onstar/onstar-payment-history'], {queryParams: params});
    }else{
      const modifiedPrams = new URLSearchParams(params).toString();
    this.window.location.href = `${this._baseHref}onstar/onstar-payment-history?${modifiedPrams}`;
    }
  };
    
}
